import EditableTable from '@components/EditableTable';
import { IDevice } from '@pages/Assets/Inventory/types';
import { Input, Space } from 'antd';
import React, { useEffect, useMemo, useState } from 'react';
import { useTranslation } from 'react-i18next';
import { IDeviceActionRequestPayload } from '../types';

interface IAddCreditProps {
  handleDeviceActions: (item: IDeviceActionRequestPayload) => void;
  actionKey: number;
  devicesProps: IDevice[] | undefined;
  uploadedDevices: any;
}

function useAddCredit({
  actionKey,
  devicesProps,
  uploadedDevices,
  handleDeviceActions,
}: IAddCreditProps) {
  const { t: translate } = useTranslation(['device-actions-modal']);
  const [devicesToExchangeData, setDevicesToExchangeData] = useState<any[]>();

  useEffect(() => {
    setDevicesToExchangeData(
      devicesProps?.map(device => ({
        key: device.id,
        msisdn: device.msisdn,
        iccid: device.iccid,
        processData: undefined,
      })),
    );
  }, [devicesProps]);

  const contentSteps = useMemo(() => {
    const handleChange = (value: string) => {
      setDevicesToExchangeData([
        { ...devicesToExchangeData?.[0], processData: value },
      ]);
    };
    if (devicesProps && devicesProps?.length > 0) {
      return [
        {
          title: translate('steps.credit'),
          content:
            devicesProps && devicesProps?.length > 1 ? (
              <EditableTable
                data={devicesToExchangeData ?? []}
                columns={[
                  {
                    title: 'MSISDN',
                    key: 'msisdn',
                    dataIndex: 'msisdn',
                  },
                  {
                    title: 'MB',
                    key: 'processData',
                    dataIndex: 'processData',
                    editable: true,
                    isRequired: true,
                  },
                ]}
                allowDelete={false}
                onChange={setDevicesToExchangeData}
              />
            ) : (
              <div style={{ padding: 16 }}>
                <Space style={{ textAlign: 'right' }}>
                  <span>MSISDN</span>
                  <span style={{ fontWeight: 'bold', fontSize: '0.8rem' }}>
                    {devicesToExchangeData?.[0]?.msisdn}
                  </span>
                </Space>
                <Input
                  addonAfter="MB"
                  onChange={({ target: { value } }) => handleChange(value)}
                  allowClear
                  width="100px"
                />
              </div>
            ),
        },
      ];
    }
    return [];
  }, [devicesProps, translate, devicesToExchangeData]);

  const reinitState = () => {
    setDevicesToExchangeData(undefined);
  };

  const onSubmit = () => {
    const payload: IDeviceActionRequestPayload = {};
    payload.action = actionKey;
    payload.devices =
      devicesProps && devicesProps?.length > 0
        ? devicesProps?.map(({ msisdn }: IDevice) => {
            return {
              msisdn,
              processData:
                devicesToExchangeData?.find(
                  (item: any) => item.msisdn === msisdn,
                ).processData || [],
            };
          })
        : uploadedDevices.map(({ ICCID, ...device }: IDevice) => ({
            ...device,
            processData: ICCID,
          }));

    return handleDeviceActions(payload);
  };

  const addCreditData = {
    contentSteps,
    onSubmit,
    reinitState,
  };

  return { addCreditData };
}

export default useAddCredit;
